import { ClaimItemsGetUseCase } from '../../../application';

export default class ClaimItemsGetService {
    constructor() {}

    async execute(event) {
        const request = await ClaimItemsGetUseCase(event);

        return request;
    }
}
